export default {
    banners:[],
}
